export default {
    banners:[],
}
